import React, { useState, useEffect } from 'react'
import { Button, Col, Icon, IconButton, Input, InputGroup, Panel, Row, SelectPicker } from 'rsuite'
import { useForm, Controller, useFieldArray } from 'react-hook-form'
import { useHistory } from 'react-router-dom'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import SearchButton from '../../components/buttons/searchButton/SearchButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import { v4 as uuidv4 } from 'uuid'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import { includes, isEmpty } from 'lodash-es'
import notification from '../../utils/notification'
import pathname from '../../constants/pathname'
import { saveAssessmentConfigType } from '../../redux/actions/assessment'
import { DEFAULT_ERR_MSG, SAVE_SUCCESS_MSG } from '../../constants/msgText'
import { doneLoading, startLoading } from '../../utils/loading'

export default function AddEvaluationTypeWidget(props) {
  const history = useHistory()
  const [formSchema, setFormSchema] = useState(props.schema)
  const [isLoading, setIsLoading] = useState(false)
  const [assessmentType, setAssessmentType] = useState(
    props.schema?.form?.assessmentType?.value || null
  )
  const [categories, setCategories] = useState(
    props.schema?.form?.assessmentTreeType?.length > 0
      ? props.schema?.form?.assessmentTreeType
      : [{ id: `${uuidv4()}`, value: null, children: [] }]
  )

  const clone = (obj) => JSON.parse(JSON.stringify(obj))

  const handleSave = async (repuest) => {
    setIsLoading(true)
    startLoading()

    try {
      const response = await saveAssessmentConfigType(repuest)
      if (response) {
        setFormSchema(response)
        setCategories(response?.form?.assessmentTreeType)

        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        notification.open('error', {
          title: e.response.data.errors?.message,
          duration: 5000,
        })
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    }

    doneLoading()
    setIsLoading(false)
  }

  const handleChange = (path, value, key) => {
    const updated = clone(categories)
    let current = updated

    path.forEach((i, idx) => {
      if (idx === path.length - 1) {
        // เก็บค่าที่กรอกใน value เท่านั้น ไม่ยุ่งกับ label
        current[i][key] = value
      } else {
        current = current[i].children
      }
    })
    setCategories(updated)
  }

  // const handleAddSameLevel = (path) => {
  //   const updated = clone(categories)
  //   let current = updated
  //   let parent = null
  //   path.slice(0, -1).forEach((i) => {
  //     parent = current[i]
  //     current = current[i].children
  //   })

  //   const newid = `new-${uuidv4()}`
  //   current.push({ id: newid, value: null, parentId: parent ? parent.id : null, children: [] })
  //   setCategories(updated)
  // }
  
  const handleAddSameLevel = (path) => {
    const updated = clone(categories)
    let current = updated
    let parent = null

    // เดินตาม path เพื่อหา parent node
    path.slice(0, -1).forEach((i) => {
      parent = current[i]
      current = current[i].children
    })

    const index = path[path.length - 1] // index ของ node ปัจจุบัน
    const newid = `new-${uuidv4()}`
    const newNode = {
      id: newid,
      value: null,
      parentId: parent ? parent.id : null,
      children: [],
    }

    // แทรก node ใหม่ หลังจาก node ปัจจุบัน (index + 1)
    current.splice(index + 1, 0, newNode)

    setCategories(updated)
  }

  const handleAddChild = (path) => {
    const updated = clone(categories)
    let current = updated
    let parent = null
    path.forEach((i) => {
      parent = current[i]
      current = current[i].children
    })

    const newid = `new-${uuidv4()}`
    current.push({ id: newid, value: null, parentId: parent ? parent.id : null, children: [] })
    setCategories(updated)
  }

  const handleRemove = (path) => {
    const updated = clone(categories)
    const lastIndex = path[path.length - 1]
    let current = updated

    // หาตำแหน่งของ parent array
    path.slice(0, -1).forEach((i) => {
      current = current[i].children
    })

    if (path.length === 1 && current.length <= 1) {
      notification.open('error', {
        title: 'ไม่สามารถลบได้ ต้องเหลือหมวดหมู่หลักไว้อย่างน้อย 1 รายการ',
        duration: 5000,
      })
      return
    }
    current.splice(lastIndex, 1)
    setCategories(updated)
  }

const removeNewPrefix = (data) => {
  if (!Array.isArray(data)) return [];

  return data.map((item) => {

    const updated = { ...item };

    if (typeof updated.id === "string" && updated.id.includes("new-")) {
      updated.id = updated.id.replace('new-', "");
    }

    if (typeof updated.parentId === "string" && updated.parentId.includes("new-")) {
      updated.parentId = updated.parentId.replace('new-', "");
    }

    if (Array.isArray(updated.children) && updated.children.length > 0) {
      updated.children = removeNewPrefix(updated.children);
    }

    return updated;
    });
  };


  const renderInputs = (items, path = []) => {
    return items.map((item, index) => {
      if (item.isDeleted) {
        return
      }

      const currentPath = [...path, index]
      const isLast = index === items.length - 1
      return (
        <div
          key={item.id || currentPath.join('-')}
          style={{ marginLeft: isEmpty(path) ? 0 : 20, marginBottom: 10 }}
        >
          <InputGroup style={{ width: '100%', marginBottom: 10 }}>
            <Input
              value={item.value || ''}
              onChange={(val) => handleChange(currentPath, val, 'value')}
              placeholder={isEmpty(path) ? 'หมวดหมู่แบบประเมิน' : 'ชื่อหมวดหมู่ย่อย'}
              style={{ flex: 1 }}
            />
            <InputGroup.Button
              onClick={() => {
                if(item.id.includes('new-')){
                  handleRemove(currentPath)
                }else {
                  handleChange(currentPath, true, 'isDeleted')
                }
              }}
              //onClick={() => handleRemove(currentPath)}
              className="rs-btn-input-group-delete"
            >
              <Icon icon="trash" className="bt-gost-icon-radius-cancel" />
            </InputGroup.Button>
            
            <InputGroup.Button
              onClick={() => handleAddSameLevel(currentPath)}
              className="rs-btn-input-group-save"
            >
              {/* ➕ เพิ่ม */}
              <Icon icon="plus" style={{ marginRight: 10 }} />
              เพิ่ม
            </InputGroup.Button>
            
            <InputGroup.Button
              onClick={() => handleAddChild(currentPath)}
              className="rs-btn-input-group-info"
            >
              <Icon icon="plus" style={{ marginRight: 10 }} />
              เพิ่มหมวดหมู่ย่อย
            </InputGroup.Button>
          </InputGroup>

          {/* Recursive call for children */}
          {item.children && item.children.length > 0 && renderInputs(item.children, currentPath)}
        </div>
      )
    })
  }

  const handleSubmit = () => {
    console.log('📦 หมวดหมู่ทั้งหมด:', categories)
    console.log('📦 ประเภทแบบประเมิน:', assessmentType)

    var _categories = removeNewPrefix(categories)
    // สร้าง object ตาม format ที่ต้องการ
    const formData = {
      assessmentType: assessmentType,
      assessmentTreeType: _categories,
    }
    console.log('📦 ข้อมูลฟอร์ม:', formData)

    handleSave(formData)
  }

  const handleCancel = () => {
    history.push({
      pathname: pathname.assessment.assessmentSettingPage,
    })
    // setAssessmentType(formSchema?.form?.assessmentType?.value || null)
    // setCategories(
    //   formSchema?.form?.assessmentTreeType || [
    //     {id: 'cat-1', value: null, children: [] },
    //   ]
    // )
  }

  const handleAddBlock = () => {
    setCategories([{ id: `${uuidv4()}`, value: null, parentId: null, children: [] }])
  }

  return (
    <Panel
      shaded
      collapsible
      defaultExpanded
      header={formSchema?.header || 'เพิ่มแบบฟอร์มการประเมิน'}
      bordered
    >
      <Row style={{ marginBottom: 10 }}>
        <Col lg={20} md={20} sm={24} xs={24}>
          <b>{formSchema?.form?.assessmentType?.label || 'ประเภทแบบประเมิน'}</b>
          <SelectPicker
            searchable={false}
            value={assessmentType}
            data={formSchema?.form?.assessmentType?.options || []}
            block
            placeholder="ประเภทแบบประเมิน"
            onChange={(value) => {
              setAssessmentType(value)
            }}
            disabled={true}
            style={{ opacity: 1 }}
          />
        </Col>
        <Col lg={4} md={4} sm={24} xs={24}></Col>
        <br />
        <br />
      </Row>

      <Row style={{ marginBottom: 10 }}>
        <Col lg={24} md={24} sm={24} xs={24}>
          <b>หมวดหมู่แบบประเมิน</b>
          {renderInputs(categories)}
        </Col>
      </Row>

      {categories.filter((i) => i.isDeleted != true).length == 0 && (
        <Button onClick={() => handleAddBlock()} appearance="primary" icon={<Icon icon="plus" />}>
          เพิ่มชุดคำถาม
        </Button>
      )}

      <Row>
        <Col lg={16} md={16} sm={24} xs={24}></Col>
        <Col lg={8} md={8} sm={24} xs={24} style={{ textAlign: 'right' }}>
          <SaveButton onClick={handleSubmit} style={{ marginRight: 10, marginBottom: 10 }}>
            บันทึก
          </SaveButton>
          <CancelButton onClick={handleCancel}>ยกเลิก</CancelButton>
        </Col>
      </Row>
    </Panel>
  )
}
